import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MultimediaService } from 'src/app/services/apis/multimedia.service';
import { TranslationService } from 'src/app/i18n/translation.service';
import { SharedService } from 'src/app/services/shared.service';
import { forkJoin, catchError, of, Subscription } from 'rxjs';
import { logMessage } from 'src/app/helpers/logs';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ResizeService } from 'src/app/services/resize.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @ViewChild('footer', { static: true }) footerElement!: ElementRef;

  isDataReady: boolean = false;
  lang: string = 'en';
  @Input() pageType: string = "";
  cYear: number = (new Date()).getFullYear();

  socialLinks: any = [];
  woqoodApp: any = [];
  bottomMenu: any = {
    fahes: {
      en: [],
      ar: []
    },
    woqod: {
      en: [],
      ar: []
    },
    qjet: {
      en: [],
      ar: []
    }    
  };
  topMenu: any = {
    fahes: {
      en: [],
      ar: []
    },
    woqod: {
      en: [],
      ar: []
    },
    qjet: {
      en: [],
      ar: []
    }    
  };
  private routerEventsSubscription: Subscription;
  isAlreadyInitiated: boolean = false;

  constructor(
    private multimediaService: MultimediaService,
    private TranslationService: TranslationService,
    private sharedService: SharedService,
    private router: Router,
    private resizeService: ResizeService,
  ) {
    // this.fetchData();
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!this.isAlreadyInitiated) this.isAlreadyInitiated = true;
        this.fetchData();
      }
    });
  }

    ngOnInit(): void{
      if (!this.isAlreadyInitiated) this.fetchData();
    }

  ngOnDestroy() {
    // Unsubscribe from router events to prevent memory leaks
    this.routerEventsSubscription.unsubscribe();
  }

  isEnAlreadyFetched: boolean = false;
  isArAlreadyFetched: boolean = false;  

  fetchData() {
    this.lang = this.TranslationService.getSelectedLanguage();

    

    if(this.lang === 'en' && this.isEnAlreadyFetched) return;
    if(this.lang === 'ar' && this.isArAlreadyFetched) return;

    if(this.lang === 'en' && !this.isEnAlreadyFetched) this.isEnAlreadyFetched = true;
    if(this.lang === 'ar' && !this.isArAlreadyFetched) this.isArAlreadyFetched = true;    

    this.isDataReady = false;
    forkJoin({
      getHomePageApp: this.multimediaService.getHomePageApp({},{Deviceprint:'iphone'}).pipe(catchError(err => of(null))),
      getSocialLinksFahes: this.pageType === 'fahes' ?  this.multimediaService.getSocialLinksFahes().pipe(catchError(err => of(null))): of(null),
      getSocialLinksQjet: this.pageType === 'qjet' ?  this.multimediaService.getSocialLinksQJET().pipe(catchError(err => of(null))): of(null),      
      getFooterBottom: this.multimediaService.getFooterBottom({}, this.lang, this.pageType).pipe(catchError(err => of(null))),
      getFooter: this.multimediaService.getFooter({}, this.lang, this.pageType).pipe(catchError(err => of(null))),
    }).subscribe({
      next: (results) => {
        logMessage('Footer Response ', results);
        if (results.getHomePageApp) this.getHomePageApp(results.getHomePageApp);
        // if (results.getSocialLinks) this.getSocialLinks(results.getSocialLinks);
        if (results.getSocialLinksFahes) this.getSocialLinksFahes(results.getSocialLinksFahes);
        if (results.getSocialLinksQjet) this.getSocialLinksQjet(results.getSocialLinksQjet);        
        if (results.getFooterBottom) this.getFooterBottom(results.getFooterBottom);
        if (results.getFooter) this.getFooter(results.getFooter);
        this.isDataReady = true;
        this.handleEmptyFooterItems();
      },
      error: (err) => {
        logMessage('FOOTER Unexpected error in forkJoin:', err);
      }
    });
  }

  handleEmptyFooterItems(){
    if(typeof window !== 'undefined'){
      setTimeout(() => {
        const footerEle:any = this.footerElement.nativeElement;
        if(!footerEle) return;
        // const footerEleLeft = footerEle.querySelectorAll(".left-side-footer");
        const footerEleRight = footerEle.querySelectorAll(".right-side-footer");            

        footerEleRight.forEach((element:any) => {
          const itemInside = element.querySelector("right-side-footer-item");
          if(!itemInside){
            if(element.previousElementSibling) {
              // console.log(element.previousElementSibling);
              
              element.previousElementSibling.classList.add('full-view');
              element.classList.add('hide-view');
            }
          }
        });
      });
    }
  }

  scrollTop(event: any) {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  getFooterBottom(response: any): void {
    const list = response?.jsonBottomTreeItems ? JSON.parse(response?.jsonBottomTreeItems) : [];
    if (list.length === 0) return;
    this.bottomMenu[this.pageType][this.lang] = list.map((item: any) => {
      return {
        title: {
          en: item.titleEN,
          ar: item.titleAR
        },
        link: item.URL,
        target: item.Target
      }
    });
  }

  getFooter(response: any): void {
    const footerStr = response?.jsonTreeItems;
    if (!footerStr) return;
    const footerFull = JSON.parse(footerStr);

    if (!footerFull) return;
    const root = footerFull && footerFull.length > 0 ? footerFull[0] : null;
    if (!root) return;
    const footer = root && root.children ? root.children : null;
    if (!footer) return;

    let temp = [];
    for (let index = 0; index < footer.length; index++) {
      if (footer[index].data.IsSectionVisible === 'True') {
        temp.push({
          title: footer[index].text || '',
          link: footer[index].data.URL || '',
          target: footer[index].data.Target,
          list: [[this.handleInnerItems(footer[index].children || [])]],
          isActive: false
        });
      }
    }

    this.topMenu[this.pageType][this.lang] = this.groupArrayItems(temp);
    this.topMenu[this.pageType][this.lang] = this.groupArrayItemsInner(this.topMenu[this.pageType][this.lang]);
    this.onResize();
  }

  groupArrayItemsInner(array: any){
    for (let index = 0; index < array.length; index++) {
      const cIteration = array[index];      
      for (let index2 = 0; index2 < cIteration.length; index2++) {
        const innerCIteration = cIteration[index2].list;
        for (let index3 = 0; index3 < innerCIteration.length; index3++) {
          const innerInnerCIteration = innerCIteration[index3];
          for (let index4 = 0; index4 < innerInnerCIteration.length; index4++) {
            const lastIteration = innerInnerCIteration[index4]; 
            array[index][index2].list[index3][index4] = this.chunkArray(lastIteration);
          }
        }   
      }
    }
    return array;
  }

chunkArray(array: any[]): any[][] {
  let size: number = array.length > 16 ? Math.round(array.length / 2) : 8;
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}


  handleInnerItems(childrens: any) {
    return (childrens || []).filter((item: any) => item.data.IsSectionVisible === 'True').map((item: any) => {
      return {
        title: item.text || '',
        link: item.data.URL || '',
        target: item.data.Target,
      }
    });

  }

  @HostListener('window:resize', ['$event']) onWindowResize() {
    this.onResize();
  }  

  onResize() {
    const isMobile = this.resizeService.isMobile();
    if(isMobile){
      for (let index = 0; index < this.topMenu[this.pageType][this.lang].length; index++) {
        for (let index2 = 0; index2 < this.topMenu[this.pageType][this.lang][index].length; index2++) {
          this.topMenu[this.pageType][this.lang][index][index2].isActive = false;
        }
      }
    }else{
      for (let index = 0; index < this.topMenu[this.pageType][this.lang].length; index++) {
        for (let index2 = 0; index2 < this.topMenu[this.pageType][this.lang][index].length; index2++) {
          this.topMenu[this.pageType][this.lang][index][index2].isActive = true;
        }
      }
    }
  }

  groupArrayItems(array: any) {
    const result = [];
    for (let i = 0; i < array.length; i += 3) {
      result.push(array.slice(i, i + 3));
    }
    return result;
  }

  isExternalMethod(link: string) {
    return this.sharedService.isExternalMethod(link);
  }

  getSocialLinks(response: any) {
    this.socialLinks = (response || []).map((item: any) => {
      return {
        icon: item.footerIconID,
        href: item.url,
      }
    });
  }
  
  getSocialLinksFahes(response: any) {
    this.socialLinks = (response || []).map((item: any) => {
      return {
        icon: item.iconId,
        href: item.url,
      }
    });
  }

    getSocialLinksQjet(response: any) {
    this.socialLinks = (response || []).map((item: any) => {
      return {
        icon: item.iconId,
        href: item.url,
      }
    });
  }

  baseURL() {
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    const isMdSite = path.indexOf("/web/") !== -1;
    const isMawSite = path.indexOf("/web1/") !== -1;
    if (isMdSite) return '/web';
    if (isMawSite) return '/web1';
    return '';
    // 
    // md -> /web
    // maw -> /web1
    // local -> empty
  }

  getHomePageApp(response: any) {
    if (Array.isArray(response) && response.length > 0) {
      this.woqoodApp = response.map((item: any) => ({
        title: {
          en: item.textEN,
          ar: item.textAR,
        },
        imgOne: item.imageOneID,
        urlOne: item.imageOneURL,
        imgTwo: item.imageTwoID,
        urlTwo: item.imageTwoURL,
        icon: item.iconID,
      }));
    }
  }

  onPlusClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    // Your custom logic here, e.g., open dropdown
    console.log('Plus icon clicked');
  }


}
